import React, { useState, useEffect } from 'react';
import { Avatar, Layout } from 'antd';
import { useHistory, Link } from 'react-router-dom';
import { logoutAndRedirect, authService } from '../core/auth';
import {
    UserOutlined,
    ArrowLeftOutlined,
    BankOutlined,
    LogoutOutlined
} from '@ant-design/icons';
import { Menu, Dropdown } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { routeConfig } from '../shared/common/constant';
import './../styles/layout.scss'
// import { useStore } from '../shared/hooks/stateStore';
const { Header } = Layout;

const HeaderBar = ({ goBackData, goBackClicked }) => {
    const history = useHistory();
    const [userName, setUserName] = useState<string>(null);

    useEffect(() => {
        const authSubcription = authService.userNameFunc().subscribe(x => setUserName(x));
        return () => {
            authSubcription.unsubscribe();
        }
    }, []);

    const logout = () => {
        logoutAndRedirect();
        history.push(routeConfig.login.path);
    }


    const menu = (
        <Menu>
            <Menu.Item>
                <Link to={routeConfig.account.path}><UserOutlined /> My Account</Link>
            </Menu.Item>
            <Menu.Item>
                <Link to={routeConfig.companyAllBanksList.path}><BankOutlined /> {routeConfig.companyAllBanksList.name}</Link>
            </Menu.Item>
            <Menu.Divider />
            <Menu.Item onClick={logout}>
                <LogoutOutlined />Logout
            </Menu.Item>
        </Menu>
    );
    const goBack = () => {
        let goBackUrl
        switch (goBackData) {
            case 1:
            case 7:
                goBackUrl = routeConfig.proformaList.path;
                break;
            case 2:
            case 8:
                goBackUrl = routeConfig.preShipmentList.path;
                break;
            case 3:
            case 9:
                goBackUrl = routeConfig.commercialInvoiceList.path;
                break;
            case 4:
            case 10:
                goBackUrl = routeConfig.allPackingList.path;
                break;
            case 5:
            case 11:
                goBackUrl = routeConfig.purchaseOrderList.path;
                break;
            case 6:
            case 12:
                goBackUrl = routeConfig.allFinalPackingList.path;
                break;
            default:
                break;
        }
        if(goBackData < 6) {
            goBackClicked();
        }
        history.push(goBackUrl);
    }
    // const saveInvoice = () => {
    //     useStore.setState({ saveInvoice: goBackData });
    // }
    return (
        <Header className="site-layout-background" style={{ padding: 0 }}>
            <div style={{ float: 'right' }}>

                {userName &&
                    <Dropdown overlay={menu} trigger={['click']}>
                        <a className="user-name-link" onClick={e => e.preventDefault()}>
                            <Avatar style={{ backgroundColor: '#1890ff', verticalAlign: 'middle', marginRight: 5, color: '#e6f7ff' }} size="default" gap={1}>
                                {userName.toUpperCase().charAt(0)}
                            </Avatar>
                            {userName} <DownOutlined />
                        </a>
                    </Dropdown>
                }
            </div>
            {
                goBackData ?
                    <>
                        <span className="pl--1_5">
                            <button className="btn--custom  btn--2 btn--icon" onClick={goBack}>
                                <ArrowLeftOutlined />
                            </button>
                        </span>
                        {/* {!hideSaveButton && <span style={{ float: 'right' }}>
                            <Button type="primary" className="mr--1" onClick={saveInvoice}>Save</Button>
                        </span>} */}
                    </> : <> </>
            }
        </Header>
    );
}
export default HeaderBar

// change password
// forgot password
// pdf of 100% height
// dynamic header & footer
